<script setup lang="ts">
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'
import SplitText from 'gsap/SplitText'
import ScrollTrigger from 'gsap/ScrollTrigger'
import type { SectionBigLeadRecord } from '~/types/datocms'

const props = defineProps<{
  data: SectionBigLeadRecord
  moduleIndex: number
}>()

const appStore = useAppStore()
const sectionRef = ref<HTMLElement | null>(null)
const textRef = ref<HTMLElement | null>(null)
let ctx: gsap.Context | null = null

onMounted(async () => {
  if (props.data.background === 'Yellow') {
    appStore.setTheme('dark')
    appStore.setGradientHeader('yellow')
  }

  await nextTick()
  useTimeoutFn(() => {
    if (textRef.value && sectionRef.value) {
      ctx = gsap.context(() => {
        gsap.registerPlugin(SplitText, ScrollTrigger)

        const split = new SplitText(textRef.value, {
          type: 'lines',
          linesClass: 'line'
        })

        gsap.set(split.lines, { opacity: 0, y: 40 })

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: sectionRef.value,
            start: 'top 80%',
            end: 'bottom 50%',
            scrub: 0.3
          }
        })

        tl.to(split.lines, {
          opacity: 1,
          y: 0,
          ease: 'power2.out',
          stagger: {
            amount: 1
          }
        })

        ScrollTrigger.refresh()
      }, sectionRef.value as HTMLElement)
    }
  }, 50)
})

onUnmounted(() => {
  if (ctx) {
    ctx.revert()
  }
})
</script>

<template>
  <section
    ref="sectionRef"
    class="py-24 font-light lg:py-36 lg:text-center"
    :class="data.background === 'Black' ? 'bg-black text-yellow' : 'bg-yellow text-black'"
  >
    <div class="container text-3xl uppercase lg:text-5xl">
      <div v-if="data.content" ref="textRef">
        {{ data.content }}
      </div>
    </div>
  </section>
</template>
